"use client";
import styles from "../app/layout.module.scss";
import { useLegalModal } from "@/context/LegalModalContext";
import { useLanguage } from "@/context/LanguageContext";

export default function FooterClient() {
  const { openModal } = useLegalModal();
  const { t } = useLanguage();

  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.footerBottomContent}>
        <p className={styles.copyright}>
          {t('footer.copyright')}
        </p>

        <div className={styles.footerBottomLinks}>
          <span onClick={() => openModal("privacy")}>{t('footer.privacy')}</span>
          <span className={styles.separator}>•</span>

          <span onClick={() => openModal("terms")}>{t('footer.terms')}</span>
          <span className={styles.separator}>•</span>

          <span onClick={() => openModal("security")}>{t('footer.security')}</span>
        </div>
      </div>
    </footer>
  );
}
